import { render, staticRenderFns } from "./customerPayback.vue?vue&type=template&id=4836cc84&scoped=true&"
import script from "./customerPayback.vue?vue&type=script&lang=js&"
export * from "./customerPayback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4836cc84",
  null
  
)

export default component.exports